import { h, Component } from 'preact';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CSSTransition from 'react-transition-group/CSSTransition';
import SlickSlider from 'react-slick';

// Components
import Steps from '../../Steps';
import { getEnvValue } from '../../../utilities/api/common';
import { replaceAll } from '../../../utilities/common';

class LoaderType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderProgressHeight: 0.025,
    };
  }

  render() {
    const {
      currentProgress,
      loaderProgress,
      pageData,
      pageData: { pageId, loaderType, loaderText, loaderTime, sliderTime, graphicLoader },
      userData,
      env,
      translations,
    } = this.props;
    let { loaderProgressHeight } = this.state;
    const simLoading = loaderProgress <= 1;

    const loaderWrapperClass = classNames(
      'loader',
      'loader--simLoading', {
        [`loader--${loaderType}`]: loaderType,
      }
    );
    let showLoader = true;

    if (loaderProgress >= 1) {
      setTimeout(() => {
        this.setState({
          loaderProgressHeight: 1,
        });
      }, 1500);
    } else {
      const { currentPageData: { currentPageId } } = currentProgress;
      if (currentPageId !== pageId) {
        showLoader = false;
      }
      loaderProgressHeight = 0.025;
    }

    if (graphicLoader) {
      showLoader = false;
    }

    // Slick settings
    const slickSettings = {
      dots: false,
      arrows: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      autoplay: true,
      autoplaySpeed: getEnvValue(env, sliderTime),
      swipe: false,
      infinite: false,
    };

    return (
      <section className={loaderWrapperClass}>

        {/* Steps */}
        {pageData.steps &&
        <Steps
          pageData={pageData}
          currentProgress={currentProgress}
          currentValues={userData}
        />
        }

        {showLoader && /* Simulating Loader Line */
        <CSSTransition
          in={simLoading}
          timeout={300}
          classNames="slideInTop"
          unmountOnExit
        >
          <div
            className="loader__line loader__line--simulate"
            style={{ 'animation-duration': getEnvValue(env, loaderTime) }}
          />
        </CSSTransition>
        }
        {showLoader && loaderText &&
        <div className="loader__text">
          <div className="slider__content">
            <SlickSlider {...slickSettings}>
              {loaderText.map(text =>
                <div className="slider__text">
                  {replaceAll(text, translations, userData)}
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </div>
              )}
            </SlickSlider>
          </div>
        </div>
        }
        {showLoader && /* Loading Line */
        <div
          className="loader__line"
          style={{ transform: `scale3d(${loaderProgress}, ${loaderProgressHeight}, 1)` }}
        />
        }

      </section>
    );
  }
}

export default compose(
  connect(state => {
    const {
      section: {
        packageData: {
          env,
          translations,
        },
      },
    } = state;
    return {
      env,
      translations,
    };
  })
)(LoaderType);

LoaderType.propTypes = {
  pageData: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  currentProgress: PropTypes.object.isRequired,
  loaderProgress: PropTypes.number.isRequired,
  env: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Page/Loader/index.jsx